import { SCORE_ANCHOR_CARD } from '../../../Constants/Score';
import { CardModifierType } from '../../../Prototype/Level/Card/CardModifierType';
import { CardStatus } from '../../../Prototype/Level/Card/CardStatus';
import { IGameState } from '../../Game/IGameState';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import BaseCardBehavior from './BaseCardBehavior';

export default class AnchorCardBehavior extends BaseCardBehavior {
    public update(state: IGameState) {
        // If there are no water modifiers left in-play then this card is discarded.
        if (
            state.levelState.cardsState.inPlay.some(cardID =>
                state.levelState.cardsState.cards[cardID].modifiers.some(
                    modifier => modifier.type === CardModifierType.water
                )
            ) === false &&
            CardStateHelper.getCardStatus(state, this.cardID) ===
                CardStatus.IN_PLAY
        ) {
            state = CardStateHelper.setCardDiscarded(state, this.cardID);
            state = CardStateHelper.addTurnScore(state, SCORE_ANCHOR_CARD);
            state = CardStateHelper.setStateTaskData(state, {
                task: CardTask.ANCHOR,
                cards: [this.cardID],
                cardsScore: [SCORE_ANCHOR_CARD],
            });

            // Clear the undo history when the anchor is discarded.
            state = CardStateHelper.clearUndoHistory(state);
        }

        return state;
    }

    public isPlayable(): boolean {
        return false;
    }
}
